import React from 'react';
import './ScrollArrow.css';

export default function ScrollArrow() {
  const [nextId, setNextId] = React.useState(null);

  const findNext = React.useCallback(() => {
    const anchors = Array.from(document.getElementsByClassName('anchor_tags'))
      .filter(Boolean)
      .sort((a, b) => a.offsetTop - b.offsetTop);
    const y = window.scrollY || window.pageYOffset;

    // If we're at (or very near) the bottom of the document, hide the arrow
    const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    const viewportBottom = y + window.innerHeight;
    const bottomThreshold = 60; // px from the bottom to consider "at end"
    if (viewportBottom >= docHeight - bottomThreshold) {
      setNextId(null);
      return;
    }

    // find first anchor below current scroll + 10px
    const next = anchors.find(a => a.offsetTop > y + 10);
    setNextId(next ? next.id : null);
  }, []);

  React.useEffect(() => {
    findNext();
    window.addEventListener('scroll', findNext, { passive: true });
    window.addEventListener('resize', findNext);
    return () => {
      window.removeEventListener('scroll', findNext);
      window.removeEventListener('resize', findNext);
    };
  }, [findNext]);

  const handleClick = (e) => {
    e.preventDefault();
    if (!nextId) return;
    const el = document.getElementById(nextId);
    if (!el) return;
    window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
    // update hash after a short delay so history behaves nicely
    setTimeout(() => { window.location.hash = `#${nextId}`; }, 600);
  };

  return (
    <button
      aria-label={nextId ? `Ir a ${nextId}` : 'No hay siguiente sección'}
      className={`scroll-arrow ${nextId ? 'show' : 'hide'}`}
      onClick={handleClick}
      title={nextId ? `Ir a ${nextId}` : ''}
    >
      <span className="chev">▾</span>
    </button>
  );
}
